export const serviceRecordPub= {
    methods: {
      //批量删除
      batchDelete:function (journalType,menuId) {
        this.journalType=journalType;
        this.menuId=menuId;
        this.showPublicPop=true;
      },
      initSearch:function (customerId) {
        this.spinShow=true;
        let param={
          pageNum:this.currentPage,
          pageSize:this.pageSize,
          journalType:"null",
          menuId:"null"
        };
        if(customerId){
          param["customerId"]=customerId;
        }
        this.speedChangePage=this.currentPage;
        this.getParam(this.formValidate,param);
        // 查询条件
        this.queryParam = param;
        let url="service/selectService.json";
        this.publicSearch(url,param,0);
      },
      //添加回调函数
      closeServiceRecord:function (flag) {
        this.showEditRecord=false;
        if(flag){
          this.initSearch();
        }
      },
      addServiceRecord:function (journalType,menuId,fromWhere) {
        this.journalType=journalType;
        this.menuId=menuId;
        this.serviceId="";
        this.showEditRecord=true;
        this.recordTitle="添加服务记录";
        this.fromWhere=fromWhere;
      },
      editServiceRecord:function (journalType,menuId,id,fromWhere) {
        this.journalType=journalType;
        this.menuId=menuId;
        this.serviceId=id;
        this.showEditRecord=true;
        this.recordTitle="编辑服务记录";
        this.fromWhere=fromWhere;
      },
      //单个删除
      deleteServiceRecord:function (journalType,menuId,id) {
        let param={
          journalType:journalType,
          menuId:menuId,
          id:id
        };
        let that=this;
        this.$Modal.confirm({
          title: '提示',
          content: "是否确定删除",
          onOk: () => {
            that.$http.post("service/deleteService.json",param) .then(function (res) {
              that.spinShow=false;
              let result = res.data.flag;
              if (result != "666") {
                that.$Modal.info({
                  title: '提示',
                  content: res.data.msg
                });
                return false;
              }
              that.$Message.info("删除成功");
              that.initSearch();
            });
          }
        });
      }
    }
};



// WEBPACK FOOTER //
// ./src/components/js/ServiceRecordPub.js